export default __webpack_public_path__ + "static/media/logo.ea49aaeb.png";